import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router';

import LoadingSpinner from '../components/LoadingSpinner';
import { useAdminQuery } from '../services/Queries';
import useUserContext from '../config/UserContext';

const stylesheet = {
    loadingSpinner: 'tw:mt-5',
};

function AdminRoute({ children }: { children: React.ReactNode }) {
    const { t } = useTranslation();
    const contextUser = useUserContext();
    const location = useLocation();
    const userId = contextUser?.attributes?.sub || '';
    let isAdmin = contextUser?.attributes?.admin || false;
    // Rely on the query if cognito attribute not true
    const skipAdminQuery = contextUser?.attributes?.admin != null;
    const { data, error, loading: loadingAdmin } = useAdminQuery(userId, skipAdminQuery);

    if (!isAdmin && loadingAdmin) return <LoadingSpinner className={stylesheet.loadingSpinner} />;

    if (userId && data?.isAdmin?.IsAnAdmin) {
        isAdmin = data.isAdmin.IsAnAdmin;
    }

    const destination = '/signIn';
    if (!userId) {
        const search = `?nextPage=${location.pathname}${location.search}`;
        return <Navigate to={`${destination}${search}`} replace />;
    }

    if (error) { // Avoid infinite redirect loops by not setting nextPage
        return <Navigate to={destination} replace />;
    }

    if (!isAdmin) {
        return <Navigate to="/error" state={{ message: t('pages.noMatch.pageNotFound') }} replace />;
    }
    return children;
}

export default AdminRoute;
